"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Seitentitel fuer den Rueckpfeil merken
// ============================================================
// Steht unsichtbar im `PageHeader` und merkt sich je Pfad, wie die
// Seite heisst. Fuehrt der Rueckpfeil eines spaeteren Blattes
// hierher zurueck, sagt er damit „Zurück zu Website-Relaunch“
// statt nur „Zurück“ (`lib/return-address.ts`). Gelesen wird der
// fertige Text der Ueberschrift: der Titel kann ein Bauteil sein
// (Name zum Umbenennen), und solange die Seite laedt, steht dort
// ein Balken ohne Text — der wird nicht gemerkt.
// ============================================================

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { rememberTitle } from "@/lib/return-address";

const MAX_LAENGE = 80;

export function PageTitleMemory({ name }: { name?: string }) {
  const pathname = usePathname();
  const ref = useRef<HTMLSpanElement>(null);
  // Ohne Abhaengigkeiten: nach jedem Zeichnen, auch wenn der Titel
  // nach dem Umbenennen neu vom Server kommt.
  useEffect(() => {
    const ueberschrift = ref.current?.parentElement?.querySelector("h2");
    const text = name ?? ueberschrift?.textContent?.replace(/\s+/g, " ").trim();
    if (!text) return;
    rememberTitle(pathname, text.length > MAX_LAENGE ? `${text.slice(0, MAX_LAENGE - 1)}…` : text);
  });
  return <span ref={ref} hidden />;
}
